<template>
  <calendesk-information-message
    color="error"
    :additional-class="`white--text ${additionalClass}`"
    icon-color="white"
    :icon="icon"
    :dense="dense"
  >
    <slot></slot>
  </calendesk-information-message>
</template>

<script>
import CalendeskInformationMessage from "@/lib/calendesk-js-library/components/CalendeskInformationMessage.vue";

export default {
  name: "CalendeskErrorMessage",
  components: {
    CalendeskInformationMessage,
  },
  props: {
    dense: {
      type: Boolean,
      default: false,
    },
    additionalClass: {
      type: String,
      default: "my-4",
    },
    icon: {
      type: String,
      default: "$alert",
    },
  },
};
</script>
